export { default as AcademicCapIcon } from "./AcademicCap";
export { default as AdjustmentsIcon } from "./Adjustments";
export { default as AnnotationIcon } from "./Annotation";
export { default as ArchiveIcon } from "./Archive";
export { default as ArrowCircleDownIcon } from "./ArrowCircleDown";
export { default as ArrowCircleLeftIcon } from "./ArrowCircleLeft";
export { default as ArrowCircleRightIcon } from "./ArrowCircleRight";
export { default as ArrowCircleUpIcon } from "./ArrowCircleUp";
export { default as ArrowDiagonalUpIcon } from "./ArrowDiagonalUp";
export { default as ArrowDiganolDownIcon } from "./ArrowDiganolDown";
export { default as ArrowDownIcon } from "./ArrowDown";
export { default as ArrowLeftIcon } from "./ArrowLeft";
export { default as ArrowNarrowDownIcon } from "./ArrowNarrowDown";
export { default as ArrowNarrowLeftIcon } from "./ArrowNarrowLeft";
export { default as ArrowNarrowRightIcon } from "./ArrowNarrowRight";
export { default as ArrowNarrowUpIcon } from "./ArrowNarrowUp";
export { default as ArrowRightIcon } from "./ArrowRight";
export { default as ArrowUpIcon } from "./ArrowUp";
export { default as ArrowsExpandIcon } from "./ArrowsExpand";
export { default as AtSymbolIcon } from "./AtSymbol";
export { default as BackspaceIcon } from "./Backspace";
export { default as BadgeCheckIcon } from "./BadgeCheck";
export { default as BanIcon } from "./Ban";
export { default as BeakerIcon } from "./Beaker";
export { default as BellIcon } from "./Bell";
export { default as BookOpenIcon } from "./BookOpen";
export { default as BookmarkAltIcon } from "./BookmarkAlt";
export { default as BookmarkIcon } from "./Bookmark";
export { default as BriefcaseIcon } from "./Briefcase";
export { default as CakeIcon } from "./Cake";
export { default as CalculatorIcon } from "./Calculator";
export { default as CalendarIcon } from "./Calendar";
export { default as CameraIcon } from "./Camera";
export { default as CashIcon } from "./Cash";
export { default as ChartBarIcon } from "./ChartBar";
export { default as ChartPieIcon } from "./ChartPie";
export { default as ChartSquareBarIcon } from "./ChartSquareBar";
export { default as ChatAlt2Icon } from "./ChatAlt2";
export { default as ChatAltIcon } from "./ChatAlt";
export { default as ChatIcon } from "./Chat";
export { default as CheckCircleIcon } from "./CheckCircle";
export { default as CheckIcon } from "./Check";
export { default as ChevronDoubleDownIcon } from "./ChevronDoubleDown";
export { default as ChevronDoubleLeftIcon } from "./ChevronDoubleLeft";
export { default as ChevronDoubleRightIcon } from "./ChevronDoubleRight";
export { default as ChevronDoubleUpIcon } from "./ChevronDoubleUp";
export { default as ChevronDownInCircleIcon } from "./ChevronDownInCircle";
export { default as ChevronDownIcon } from "./ChevronDown";
export { default as ChevronLeftInCircleIcon } from "./ChevronLeftInCircle";
export { default as ChevronLeftIcon } from "./ChevronLeft";
export { default as ChevronRightInCircleIcon } from "./ChevronRightInCircle";
export { default as ChevronRightIcon } from "./ChevronRight";
export { default as ChevronUpInCircleIcon } from "./ChevronUpInCircle";
export { default as ChevronUpIcon } from "./ChevronUp";
export { default as ChipIcon } from "./Chip";
export { default as ClipboardCheckIcon } from "./ClipboardCheck";
export { default as ClipboardCopyIcon } from "./ClipboardCopy";
export { default as ClipboardListIcon } from "./ClipboardList";
export { default as ClipboardIcon } from "./Clipboard";
export { default as ClockIcon } from "./Clock";
export { default as CloudDownload1Icon } from "./CloudDownload1";
export { default as CloudDownloadIcon } from "./CloudDownload";
export { default as CloudUpload1Icon } from "./CloudUpload1";
export { default as CloudUploadIcon } from "./CloudUpload";
export { default as CloudIcon } from "./Cloud";
export { default as CodeIcon } from "./Code";
export { default as CogIcon } from "./Cog";
export { default as CollectionIcon } from "./Collection";
export { default as ColorSwatchIcon } from "./ColorSwatch";
export { default as CopyIcon } from "./Copy";
export { default as CreditCardIcon } from "./CreditCard";
export { default as CryptoPaymentsIcon } from "./CryptoPayments";
export { default as CubeTransparentIcon } from "./CubeTransparent";
export { default as CubeIcon } from "./Cube";
export { default as CurrencyBangladeshiIcon } from "./CurrencyBangladeshi";
export { default as CurrencyDollarIcon } from "./CurrencyDollar";
export { default as CurrencyEuroIcon } from "./CurrencyEuro";
export { default as CurrencyPoundIcon } from "./CurrencyPound";
export { default as CurrencyRupeeIcon } from "./CurrencyRupee";
export { default as CurrencyYenIcon } from "./CurrencyYen";
export { default as CursorClickIcon } from "./CursorClick";
export { default as DatabaseIcon } from "./Database";
export { default as DesktopComputerIcon } from "./DesktopComputer";
export { default as DeviceMobileIcon } from "./DeviceMobile";
export { default as DeviceTabletIcon } from "./DeviceTablet";
export { default as DocumentAddIcon } from "./DocumentAdd";
export { default as DocumentDownloadIcon } from "./DocumentDownload";
export { default as DocumentDuplicateIcon } from "./DocumentDuplicate";
export { default as DocumentRemoveIcon } from "./DocumentRemove";
export { default as DocumentReportIcon } from "./DocumentReport";
export { default as DocumentSearchIcon } from "./DocumentSearch";
export { default as DocumentTextIcon } from "./DocumentText";
export { default as DocumentIcon } from "./Document";
export { default as DotsCircleHorizontalIcon } from "./DotsCircleHorizontal";
export { default as DotsHorizontalIcon } from "./DotsHorizontal";
export { default as DotsVerticalIcon } from "./DotsVertical";
export { default as DownloadIcon } from "./Download";
export { default as DuplicateIcon } from "./Duplicate";
export { default as EmojiHappyIcon } from "./EmojiHappy";
export { default as EmojiSadIcon } from "./EmojiSad";
export { default as ErrorIcon } from "./Error";
export { default as ExclamationCircleIcon } from "./ExclamationCircle";
export { default as ExclamationIcon } from "./Exclamation";
export { default as ExternalLinkIcon } from "./ExternalLink";
export { default as EyeOffIcon } from "./EyeOff";
export { default as EyeIcon } from "./Eye";
export { default as FastForwardIcon } from "./FastForward";
export { default as FilmIcon } from "./Film";
export { default as FilterIcon } from "./Filter";
export { default as FingerPrintIcon } from "./FingerPrint";
export { default as FireIcon } from "./Fire";
export { default as FlagIcon } from "./Flag";
export { default as FolderAddIcon } from "./FolderAdd";
export { default as FolderDownloadIcon } from "./FolderDownload";
export { default as FolderOpenIcon } from "./FolderOpen";
export { default as FolderRemoveIcon } from "./FolderRemove";
export { default as FolderIcon } from "./Folder";
export { default as GiftIcon } from "./Gift";
export { default as GlobeAltIcon } from "./GlobeAlt";
export { default as GlobeIcon } from "./Globe";
export { default as HandIcon } from "./Hand";
export { default as HashtagIcon } from "./Hashtag";
export { default as HeartIcon } from "./Heart";
export { default as HighRiskIcon } from "./HighRisk";
export { default as HomeIcon } from "./Home";
export { default as IconUserRemoveIcon } from "./IconUserRemove";
export { default as IdentificationIcon } from "./Identification";
export { default as InboxInIcon } from "./InboxIn";
export { default as InboxIcon } from "./Inbox";
export { default as InformationCircleIcon } from "./InformationCircle";
export { default as IntegrationIcon } from "./Integration";
export { default as IntentsIcon } from "./Intents";
export { default as KeyIcon } from "./Key";
export { default as LibraryIcon } from "./Library";
export { default as LightBulbIcon } from "./LightBulb";
export { default as LightningBoltIcon } from "./LightningBolt";
export { default as LinkIcon } from "./Link";
export { default as LocationMarkerIcon } from "./LocationMarker";
export { default as LockClosedIcon } from "./LockClosed";
export { default as LockOpenIcon } from "./LockOpen";
export { default as Logout1Icon } from "./Logout1";
export { default as LogoutIcon } from "./Logout";
export { default as MailOpenIcon } from "./MailOpen";
export { default as MailIcon } from "./Mail";
export { default as MapIcon } from "./Map";
export { default as MedRiskIcon } from "./MedRisk";
export { default as MenuAlt1Icon } from "./MenuAlt1";
export { default as MenuAlt2Icon } from "./MenuAlt2";
export { default as MenuAlt3Icon } from "./MenuAlt3";
export { default as MenuAlt4Icon } from "./MenuAlt4";
export { default as MenuIcon } from "./Menu";
export { default as MicrophoneIcon } from "./Microphone";
export { default as MinusCircleIcon } from "./MinusCircle";
export { default as MinusIcon } from "./Minus";
export { default as MobilePaymentIcon } from "./MobilePayment";
export { default as MoonIcon } from "./Moon";
export { default as MusicNoteIcon } from "./MusicNote";
export { default as NewspaperIcon } from "./Newspaper";
export { default as OfficeBuildingIcon } from "./OfficeBuilding";
export { default as PaperAirplaneIcon } from "./PaperAirplane";
export { default as PaperClipIcon } from "./PaperClip";
export { default as PauseIcon } from "./Pause";
export { default as PayInProviderIcon } from "./PayInProvider";
export { default as PayOutProviderIcon } from "./PayOutProvider";
export { default as PaymentProviderIcon } from "./PaymentProvider";
export { default as PencilAltIcon } from "./PencilAlt";
export { default as PencilIcon } from "./Pencil";
export { default as PhoneIncomingIcon } from "./PhoneIncoming";
export { default as PhoneMissedCallIcon } from "./PhoneMissedCall";
export { default as PhoneOutgoingIcon } from "./PhoneOutgoing";
export { default as PhoneIcon } from "./Phone";
export { default as PhotographIcon } from "./Photograph";
export { default as PinIcon } from "./Pin";
export { default as PlayIcon } from "./Play";
export { default as PlusCircleIcon } from "./PlusCircle";
export { default as PlusSmIcon } from "./PlusSm";
export { default as PlusIcon } from "./Plus";
export { default as PresentationChartBarIcon } from "./PresentationChartBar";
export { default as PresentationChartLineIcon } from "./PresentationChartLine";
export { default as PrinterIcon } from "./Printer";
export { default as ProviderLookupIcon } from "./ProviderLookup";
export { default as PuzzleIcon } from "./Puzzle";
export { default as QrcodeIcon } from "./Qrcode";
export { default as QuestionMarkCircleIcon } from "./QuestionMarkCircle";
export { default as RssIcon } from "./Rss";
export { default as ReceiptRefundIcon } from "./ReceiptRefund";
export { default as ReceiptTaxIcon } from "./ReceiptTax";
export { default as RefreshIcon } from "./Refresh";
export { default as ReplyIcon } from "./Reply";
export { default as ResizeIcon } from "./Resize";
export { default as RewindIcon } from "./Rewind";
export { default as SandboxIcon } from "./Sandbox";
export { default as SaveAsIcon } from "./SaveAs";
export { default as SaveIcon } from "./Save";
export { default as ScaleIcon } from "./Scale";
export { default as ScissorsIcon } from "./Scissors";
export { default as SearchCircleIcon } from "./SearchCircle";
export { default as SearchIcon } from "./Search";
export { default as SelectorIcon } from "./Selector";
export { default as ServerIcon } from "./Server";
export { default as ShareIcon } from "./Share";
export { default as ShieldCheckIcon } from "./ShieldCheck";
export { default as ShieldExclamationIcon } from "./ShieldExclamation";
export { default as ShoppingBagIcon } from "./ShoppingBag";
export { default as ShoppingCartIcon } from "./ShoppingCart";
export { default as SortAscendingIcon } from "./SortAscending";
export { default as SortDescendingIcon } from "./SortDescending";
export { default as SparklesIcon } from "./Sparkles";
export { default as SpeakerphoneIcon } from "./Speakerphone";
export { default as StarIcon } from "./Star";
export { default as StatusOfflineIcon } from "./StatusOffline";
export { default as StatusOnlineIcon } from "./StatusOnline";
export { default as StopIcon } from "./Stop";
export { default as StoreIcon } from "./Store";
export { default as SunIcon } from "./Sun";
export { default as SupportIcon } from "./Support";
export { default as SwitchHorizontalIcon } from "./SwitchHorizontal";
export { default as SwitchVerticalIcon } from "./SwitchVertical";
export { default as TableIcon } from "./Table";
export { default as TagIcon } from "./Tag";
export { default as TemplateIcon } from "./Template";
export { default as TerminalIcon } from "./Terminal";
export { default as ThumbDownIcon } from "./ThumbDown";
export { default as ThumbUpIcon } from "./ThumbUp";
export { default as TicketIcon } from "./Ticket";
export { default as TransactionsIcon } from "./Transactions";
export { default as TranslateIcon } from "./Translate";
export { default as TrashIcon } from "./Trash";
export { default as TrendingDownIcon } from "./TrendingDown";
export { default as TrendingUpIcon } from "./TrendingUp";
export { default as TruckIcon } from "./Truck";
export { default as UploadIcon } from "./Upload";
export { default as UserAddIcon } from "./UserAdd";
export { default as UserCircleIcon } from "./UserCircle";
export { default as UserGroupIcon } from "./UserGroup";
export { default as UserIcon } from "./User";
export { default as UsersIcon } from "./Users";
export { default as VariableIcon } from "./Variable";
export { default as VideoCameraIcon } from "./VideoCamera";
export { default as ViewBoardsIcon } from "./ViewBoards";
export { default as ViewGridAddIcon } from "./ViewGridAdd";
export { default as ViewGridIcon } from "./ViewGrid";
export { default as ViewListIcon } from "./ViewList";
export { default as VoidPaymentIcon } from "./VoidPayment";
export { default as VolumeOffIcon } from "./VolumeOff";
export { default as VolumeUpIcon } from "./VolumeUp";
export { default as WifiIcon } from "./Wifi";
export { default as XCircleIcon } from "./XCircle";
export { default as XIcon } from "./X";
export { default as ZoomInIcon } from "./ZoomIn";
export { default as ZoomOutIcon } from "./ZoomOut";
export { default as BankInstallementsIcon } from "./BankInstallements";
export { default as BitcoinBtcIcon } from "./BitcoinBtc";
export { default as CardAddIcon } from "./CardAdd";
export { default as CardEditIcon } from "./CardEdit";
export { default as CardLookupIcon } from "./CardLookup";
export { default as CardPosIcon } from "./CardPos";
export { default as CardReceiveIcon } from "./CardReceive";
export { default as CardRemove1Icon } from "./CardRemove1";
export { default as CardRemoveIcon } from "./CardRemove";
export { default as CardSendIcon } from "./CardSend";
export { default as CardSlashIcon } from "./CardSlash";
export { default as CardTick1Icon } from "./CardTick1";
export { default as CardTickIcon } from "./CardTick";
export { default as CardIcon } from "./Card";
export { default as CardsIcon } from "./Cards";
export { default as ChartSquareIcon } from "./ChartSquare";
export { default as CodeCircleIcon } from "./CodeCircle";
export { default as Coin1Icon } from "./Coin1";
export { default as CoinIcon } from "./Coin";
export { default as CommandSquareIcon } from "./CommandSquare";
export { default as CommandIcon } from "./Command";
export { default as ConvertCardIcon } from "./ConvertCard";
export { default as Data2Icon } from "./Data2";
export { default as DataIcon } from "./Data";
export { default as DiscountCircleIcon } from "./DiscountCircle";
export { default as DiscountShapeIcon } from "./DiscountShape";
export { default as DocumentCodeIcon } from "./DocumentCode";
export { default as DocumentMetaIcon } from "./DocumentMeta";
export { default as DollarCircleIcon } from "./DollarCircle";
export { default as DollarSquareIcon } from "./DollarSquare";
export { default as DragIndicatorIcon } from "./DragIndicator";
export { default as EmptyWalletAddIcon } from "./EmptyWalletAdd";
export { default as EmptyWalletAlertIcon } from "./EmptyWalletAlert";
export { default as EmptyWalletChangeIcon } from "./EmptyWalletChange";
export { default as EmptyWalletRemove1Icon } from "./EmptyWalletRemove1";
export { default as EmptyWalletRemoveIcon } from "./EmptyWalletRemove";
export { default as EmptyWalletTickIcon } from "./EmptyWalletTick";
export { default as EmptyWalletTimeIcon } from "./EmptyWalletTime";
export { default as EmptyWalletIcon } from "./EmptyWallet";
export { default as EthereumEthIcon } from "./EthereumEth";
export { default as Hierarchy2Icon } from "./Hierarchy2";
export { default as Hierarchy3Icon } from "./Hierarchy3";
export { default as HierarchySquare2Icon } from "./HierarchySquare2";
export { default as HierarchySquare3Icon } from "./HierarchySquare3";
export { default as HierarchySquareIcon } from "./HierarchySquare";
export { default as HierarchyIcon } from "./Hierarchy";
export { default as MathIcon } from "./Math";
export { default as Maximize1Icon } from "./Maximize1";
export { default as Minimize1Icon } from "./Minimize1";
export { default as Money2Icon } from "./Money2";
export { default as Money3Icon } from "./Money3";
export { default as Money4Icon } from "./Money4";
export { default as MoneyAddIcon } from "./MoneyAdd";
export { default as MoneyChangeIcon } from "./MoneyChange";
export { default as MoneyForbiddenIcon } from "./MoneyForbidden";
export { default as MoneyReciveIcon } from "./MoneyRecive";
export { default as MoneyRemoveIcon } from "./MoneyRemove";
export { default as MoneySendIcon } from "./MoneySend";
export { default as MoneyTickIcon } from "./MoneyTick";
export { default as MoneyTimeIcon } from "./MoneyTime";
export { default as MoneyIcon } from "./Money";
export { default as MoneysIcon } from "./Moneys";
export { default as OptimizationIcon } from "./Optimization";
export { default as PercentageCircleIcon } from "./PercentageCircle";
export { default as PercentageSquareIcon } from "./PercentageSquare";
export { default as ProgrammingArrowIcon } from "./ProgrammingArrow";
export { default as ProgrammingArrowsIcon } from "./ProgrammingArrows";
export { default as Receipt1Icon } from "./Receipt1";
export { default as Receipt21Icon } from "./Receipt21";
export { default as Receipt2Icon } from "./Receipt2";
export { default as ReceiptAddIcon } from "./ReceiptAdd";
export { default as ReceiptCancelIcon } from "./ReceiptCancel";
export { default as ReceiptDiscountIcon } from "./ReceiptDiscount";
export { default as ReceiptDisscountIcon } from "./ReceiptDisscount";
export { default as ReceiptEditIcon } from "./ReceiptEdit";
export { default as ReceiptItemIcon } from "./ReceiptItem";
export { default as ReceiptMinusIcon } from "./ReceiptMinus";
export { default as ReceiptSearchIcon } from "./ReceiptSearch";
export { default as ReceiptTextIcon } from "./ReceiptText";
export { default as ReceiptIcon } from "./Receipt";
export { default as SecurityCardIcon } from "./SecurityCard";
export { default as Strongbox2Icon } from "./Strongbox2";
export { default as StrongboxIcon } from "./Strongbox";
export { default as Tag2Icon } from "./Tag2";
export { default as Ticket2Icon } from "./Ticket2";
export { default as TicketDiscountIcon } from "./TicketDiscount";
export { default as TicketExpiredIcon } from "./TicketExpired";
export { default as TicketStarIcon } from "./TicketStar";
export { default as TransactionMinusIcon } from "./TransactionMinus";
export { default as UnavailRiskIcon } from "./UnavailRisk";
export { default as Wallet1Icon } from "./Wallet1";
export { default as Wallet2Icon } from "./Wallet2";
export { default as Wallet3Icon } from "./Wallet3";
export { default as WalletAdd1Icon } from "./WalletAdd1";
export { default as WalletAddIcon } from "./WalletAdd";
export { default as WalletAlertIcon } from "./WalletAlert";
export { default as WalletCheckIcon } from "./WalletCheck";
export { default as WalletMinusIcon } from "./WalletMinus";
export { default as WalletMoneyIcon } from "./WalletMoney";
export { default as WalletRemoveIcon } from "./WalletRemove";
export { default as WalletSearchIcon } from "./WalletSearch";
export { default as WalletIcon } from "./Wallet";
